// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.io.io-bill-line {
  & > label {
    flex-grow: 1;
  }

  & > .content {
    flex-basis: 5em;
    flex-grow: 0;

    text-align: right;
    width: 5em;
  }

  & > .appendix {
    flex-basis: 5em;
    flex-grow: 0;
    max-width: 5em;

    text-align: right;
  }
}
`, "",{"version":3,"sources":["webpack://./frontend/app-patient/blocs/io-bill-line.css"],"names":[],"mappings":"AAAA;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;;IAEZ,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,cAAc;;IAEd,iBAAiB;EACnB;AACF","sourcesContent":[".io.io-bill-line {\n  & > label {\n    flex-grow: 1;\n  }\n\n  & > .content {\n    flex-basis: 5em;\n    flex-grow: 0;\n\n    text-align: right;\n    width: 5em;\n  }\n\n  & > .appendix {\n    flex-basis: 5em;\n    flex-grow: 0;\n    max-width: 5em;\n\n    text-align: right;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
